/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Detail_Trial_TitleInputs */

const en_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trial Benefits`)
};

const ar_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فوائد التجربة`)
};

const de_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorteile des Tests`)
};

const es_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beneficios de la prueba`)
};

const fr_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avantages de l'essai`)
};

const it_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vantaggi della prova`)
};

const ja_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トライアル特典`)
};

const ko_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`체험판 혜택`)
};

const pt_br_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benefícios do período de teste`)
};

const ru_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Преимущества пробной версии`)
};

const th_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สิทธิประโยชน์ของการทดลองใช้`)
};

const tr_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deneme Hakları`)
};

const zh_cn_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`试用权益说明`)
};

const zh_tw_subscription_detail_trial_title = /** @type {(inputs: Subscription_Detail_Trial_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試用權益說明`)
};

/**
* | output |
* | --- |
* | "Trial Benefits" |
*
* @param {Subscription_Detail_Trial_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_detail_trial_title = /** @type {((inputs?: Subscription_Detail_Trial_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Detail_Trial_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_detail_trial_title(inputs)
	if (locale === "ar") return ar_subscription_detail_trial_title(inputs)
	if (locale === "de") return de_subscription_detail_trial_title(inputs)
	if (locale === "es") return es_subscription_detail_trial_title(inputs)
	if (locale === "fr") return fr_subscription_detail_trial_title(inputs)
	if (locale === "it") return it_subscription_detail_trial_title(inputs)
	if (locale === "ja") return ja_subscription_detail_trial_title(inputs)
	if (locale === "ko") return ko_subscription_detail_trial_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_detail_trial_title(inputs)
	if (locale === "ru") return ru_subscription_detail_trial_title(inputs)
	if (locale === "th") return th_subscription_detail_trial_title(inputs)
	if (locale === "tr") return tr_subscription_detail_trial_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_detail_trial_title(inputs)
	return zh_tw_subscription_detail_trial_title(inputs)
});